import _set from 'lodash/set'

const emojies = {
  info: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/271/information_2139-fe0f.png',
  warning: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/271/high-voltage_26a1.png',
  error: 'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/237/pensive-face_1f614.png'
}

export default {
  namespaced: true,

  state: {
    notifications: []
  },

  actions: {
    _addNotification ({ state, commit }, data) {
      _set(data, 'timestamp', Date.now())
      commit('SET_NOTIFICATIONS', [data, ...state.notifications])
    },

    addInfo ({ dispatch }, { titleLabel = 'notifications.info', msgLabel = '', event = null }) {
      const data = { type: 'info', imageLink: emojies.info, titleLabel, msgLabel, event }
      dispatch('_addNotification', data)
    },

    addWarning ({ dispatch }, { titleLabel = 'notifications.warning', msgLabel = '', event = null }) {
      const data = { type: 'warning', imageLink: emojies.warning, titleLabel, msgLabel, event }
      dispatch('_addNotification', data)
    },

    addError ({ dispatch }, { titleLabel = 'notifications.error', error = null, event = null }) {
      dispatch('_addNotification', {
        type: 'error',
        titleLabel,
        imageLink: emojies.error,
        msgLabel: error,
        event
      })
    },

    clearNotifications ({ commit }) {
      commit('SET_NOTIFICATIONS', [])
    }
  },

  mutations: {
    SET_NOTIFICATIONS (state, data) {
      _set(state, 'notifications', data)
    }
  }
}
